import React, { useRef } from "react";
import { returnIconForChild } from "../../use-cases/return-icon-for-child";
import { Button } from "@components/atoms/buttons/button/button";
import { NodeDataTypes } from "@src/reducers/your-reducer";
import styles from "../TreeComponents.module.scss";
import { OurNode } from "@src/cloud-connect/poc/our-node";
import { useNameInputOurNodeHook } from "./use-name-input-our-node-hook";
import { useI18N } from "@src/language/language-context";

interface NameInputHookTypes {
  nodeInputValue: string;
  setNodeInputValue: (value: string) => void;
  handleSaveModifiedNodeName: (node: OurNode) => void;
}
interface NameInputPropTypes {
  child: OurNode;
  nodeSelectionNodeData: NodeDataTypes;
  useHook?: (nodeSelectionNodeData, inputRef) => NameInputHookTypes;
}

export const NameInputOurNode = ({
  child,
  nodeSelectionNodeData,
  useHook = useNameInputOurNodeHook,
}: NameInputPropTypes) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const { nodeInputValue, setNodeInputValue, handleSaveModifiedNodeName } =
    useHook(nodeSelectionNodeData.nodeId, inputRef);
  const i18n = useI18N();

  const texts = {
    saveButtonText: i18n("modules.nameInputOurNode.saveButtonText"),
  };

  return (
    <span
      className={`${styles["tree-node__name-wrapper"]} ${
        styles[`tree-node__name-wrapper--${returnIconForChild(child)}`]
      }`}
    >
      <span className={styles["tree-node__name-input-wrapper"]}>
        <input
          ref={inputRef}
          type="text"
          value={nodeInputValue}
          onChange={(e) => setNodeInputValue(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              handleSaveModifiedNodeName(child);
            }
          }}
          className={styles["tree-node__name-input"]}
          // eslint-disable-next-line jsx-a11y/no-autofocus
          autoFocus
        />
        <span className={styles["tree-node__name-input-button-wrapper"]}>
          <Button
            fun={() => handleSaveModifiedNodeName(child)}
            text={texts.saveButtonText}
            variant="uppercase"
          />
        </span>
      </span>
    </span>
  );
};
